import React from 'react';
import './ComponentList.css';
import { ExistingPole, Pole, Transformer, Anchor, Switch, TerminatingCabinet, SecondaryPedestal, GeneralNote, TreeTrimming, Meter } from './EquipmentIcons';

const equipmentIcons = {
  'existing-pole': ExistingPole,
  'pole': Pole,
  'transformer': Transformer,
  'anchor': Anchor,
  'switch': Switch,
  'terminating-cabinet': TerminatingCabinet,
  'secondary-pedestal': SecondaryPedestal,
  'general-note': GeneralNote,
  'tree-trimming': TreeTrimming,
  'meter': Meter
};

const ComponentList = ({ 
  isOpen, 
  onClose, 
  equipment, 
  conductors,
  onDeleteEquipment,
  onDeleteConductor,
  onEditEquipment,
  onEditConductor,
  isReadOnly = false
}) => {
  return (
    <div className={`component-list ${isOpen ? 'open' : ''}`}>
      <div className="component-list-header">
        <h2>Components List</h2>
        <button className="close-button" onClick={onClose}>&times;</button>
      </div>
      
      <div className="component-list-content">
        {/* Equipment Section */}
        <section className="component-section">
          <h3>Equipment ({equipment.length})</h3>
          {equipment.map((item, index) => {
            const IconComponent = equipmentIcons[item.type];
            return (
              <div key={index} className="component-item">
                <div className="component-icon">
                  <IconComponent />
                </div>
                <div className="component-details">
                  <h4>{item.type.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h4>
                  {Object.entries(item.details || {}).map(([key, value]) => (
                    <p key={key}><strong>{key}:</strong> {value}</p>
                  ))}
                  {item.notes && <p><strong>Notes:</strong> {item.notes}</p>}
                </div>
                {!isReadOnly && (
                  <div className="component-actions">
                    <button onClick={() => onEditEquipment(index)} className="edit-button">Edit</button>
                    <button onClick={() => onDeleteEquipment(index)} className="delete-button">Delete</button>
                  </div>
                )}
              </div>
            );
          })}
        </section>

        {/* Conductors Section */}
        <section className="component-section">
          <h3>Conductors ({conductors.length})</h3>
          {conductors.map((conductor, index) => (
            <div key={index} className="component-item">
              <div className="component-icon conductor">
                {conductor.type.includes('underground') ? '⟿' : '⟶'}
              </div>
              <div className="component-details">
                <h4>{conductor.type.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h4>
                <p><strong>Wire Size:</strong> {conductor.wireSize}</p>
                <p><strong>Length:</strong> {conductor.length.toFixed(1)} ft</p>
                {conductor.notes && <p><strong>Notes:</strong> {conductor.notes}</p>}
              </div>
              {!isReadOnly && (
                <div className="component-actions">
                  <button onClick={() => onEditConductor(index)} className="edit-button">Edit</button>
                  <button onClick={() => onDeleteConductor(index)} className="delete-button">Delete</button>
                </div>
              )}
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default ComponentList; 